import {WpEtEnrollment} from "./wp-et-enrollment.model";
import {EmploymentPlan} from "./employment-plan.model";
export class EmploymentPlanSummary{
  constructor(
    public employmentPlan?: EmploymentPlan[],
    public etEnrollmentId?: number,
    public enrollmentEndDt?: any,
  ){
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/employment-plan-summary.model.ts